import {ContentBox} from '@hconnect/common/components/ContentBox'
import {SIDE_CARD_MIN_HEIGHT_IN_PX} from '@hconnect/common/consts'
import React from 'react'
import {useSearchParams} from 'react-router'

import {
  SideCardItemMode,
  SideCardModes,
  HProduceTaskIdentifiers,
  HProduceTask,
  TaskSource
} from '../types'

import {TaskCreate} from './TaskCreate'
import {TaskDetailsFactory} from './TaskDetails'
import {TaskEditFactory} from './TaskEdit'

const createTaskIdentifiers = (
  task?: HProduceTask,
  searchParams?: URLSearchParams
): HProduceTaskIdentifiers | null => {
  const id = task?.id ?? searchParams?.get('eventId') ?? ''
  const externalId = task?.externalId ?? searchParams?.get('externalId') ?? ''
  const plantId = task?.plantId ?? searchParams?.get('taskPlantId') ?? ''
  const source = task?.source ?? (searchParams?.get('source') as TaskSource)

  if (!id || !externalId || !plantId || !source) {
    return null
  }

  return {id, externalId, plantId, source}
}

// TODO: make it less dependant on the ShiftEvent in following tasks
type Props = SideCardModes & {
  setMode: (next: SideCardModes) => void
  doClose: (original?: HProduceTask, next?: HProduceTask) => void
  freeSearchText?: string
  timezone: string
  task?: HProduceTask
}

export const SideCard: React.FC<Props> = ({task, ...props}) => {
  // TODO: setup permission
  // const allowedToViewDocuments = usePermission('VIEW_DOCUMENTS')
  const [searchParams] = useSearchParams()

  if (props.mode === SideCardItemMode.Create) {
    return <TaskCreate onClose={props.doClose} />
  }
  const handleEditTaskClick = (taskId: string, mode?: SideCardItemMode) => {
    props.setMode({
      mode:
        mode === SideCardItemMode.EditSeries
          ? SideCardItemMode.EditSeries
          : SideCardItemMode.EditSingle,
      itemId: taskId
    })
  }

  const taskIdentifiers = createTaskIdentifiers(task, searchParams)

  if (taskIdentifiers) {
    switch (props.mode) {
      case SideCardItemMode.Details:
        return (
          <TaskDetailsFactory
            data-test-id="page-events-details"
            onClose={props.doClose}
            onEditTaskClick={handleEditTaskClick}
            taskIdentifiers={taskIdentifiers}
            taskFromList={task}
            freeSearchText={props.freeSearchText}
            timezone={props.timezone}
          />
        )

      case SideCardItemMode.EditSingle:
      case SideCardItemMode.EditSeries:
        return (
          <TaskEditFactory
            data-test-id="page-events-edit"
            isSingleEvent={props.mode === SideCardItemMode.EditSingle}
            onClose={props.doClose}
            task={taskIdentifiers}
            setMode={props.setMode}
          />
        )
    }
  }

  return (
    <ContentBox
      data-test-id="sideCard-spinner"
      isLoading
      minHeight={SIDE_CARD_MIN_HEIGHT_IN_PX}
      mode="max100PercentOfParentHeight"
    />
  )
}
